export const normalizeText = (value) => String(value ?? "").trim();

export const parseDateTimeValue = (value) => {
  const raw = normalizeText(value);
  if (!raw || raw === "-") return null;

  const match = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?$/);
  if (match) {
    const [, day, month, year, hours = "00", minutes = "00"] = match;
    const parsed = new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const parsed = new Date(`${raw}T00:00:00`);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDate = (value) => {
  const parsed = parseDateTimeValue(value);
  return parsed
    ? parsed.toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric" })
    : "";
};

export const formatTime = (value) => {
  const parsed = parseDateTimeValue(value);
  return parsed
    ? parsed.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit", hour12: true })
    : "";
};

export const dateInputValueFromDisplay = (value) => {
  const parsed = parseDateTimeValue(value);
  if (!parsed) return "";

  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const day = String(parsed.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const normalizeOnboardingAlertItem = (item = {}) => ({
  id: Number(item?.id || item?.Id || 0),
  processId: Number(item?.id || item?.Id || 0),
  processCode: normalizeText(item?.procesoCodigo || item?.ProcesoCodigo || "ONBOARDING_V2"),
  processSlug: normalizeText(item?.procesoSlug || item?.ProcesoSlug || "onboarding"),
  commerceName: normalizeText(item?.comercio || item?.Comercio || item?.razonSocial || item?.RazonSocial) || "Sin comercio",
  cuit: normalizeText(item?.cuit || item?.Cuit),
  terminal: normalizeText(item?.numeroTerminal || item?.NumeroTerminal),
  commerceNumber: normalizeText(item?.numeroComercio || item?.NumeroComercio),
  phone: normalizeText(item?.telefono || item?.Telefono),
  status: normalizeText(item?.estadoLabel || item?.EstadoLabel || item?.estadoActual || item?.EstadoActual) || "Sin estado",
  channel: normalizeText(item?.canalPermitido || item?.CanalPermitido),
  currentAttempt: Number(item?.intentoActual || item?.IntentoActual || 0),
  maxAttempts: Math.max(3, Number(item?.maximoIntentos || item?.MaximoIntentos || 3)),
  nextActionLabel: normalizeText(item?.accionPermitida || item?.AccionPermitida),
  nextActionDate: normalizeText(item?.fechaProximaAccion || item?.FechaProximaAccion),
  priority: normalizeText(item?.prioridad || item?.Prioridad),
  responsibleName: normalizeText(item?.responsable || item?.Responsable),
  canManage: item?.puedeGestionar !== false,
  canTake: Boolean(item?.puedeTomar),
  canAssign: Boolean(item?.puedeAsignar),
  canRelease: Boolean(item?.puedeLiberar),
  readOnly: Boolean(item?.esSoloLectura),
  readOnlyMessage: normalizeText(item?.mensajeSoloLectura || item?.MensajeSoloLectura),
  versionToken: normalizeText(item?.versionToken || item?.VersionToken),
  raw: item,
});

export const filterOnboardingRows = (rows, filters) => {
  const searchNeedle = normalizeText(filters.search).toLowerCase();
  const selectedDate = normalizeText(filters.date);

  return rows.filter((item) => {
    if (selectedDate && dateInputValueFromDisplay(item.nextActionDate) !== selectedDate) return false;

    if (!searchNeedle) return true;

    return [
      item.commerceName,
      item.cuit,
      item.terminal,
      item.commerceNumber,
      item.responsibleName,
      item.phone,
    ]
      .filter(Boolean)
      .some((value) => value.toLowerCase().includes(searchNeedle));
  });
};

export const inferCanGenerate = (permissions) => {
  if (!permissions) return true;

  return Boolean(
    permissions?.puedeAdministrarPostventa ||
      permissions?.puedeGestionarPostventaGeneral ||
      permissions?.puedeGestionarPostventa
  );
};

export const resolveActionLabel = (item) =>
  item.readOnly || item.canManage === false ? "Ver detalle" : "Gestionar";

export const buildAttemptLabel = (currentAttempt, maxAttempts) => {
  const current = Number.isFinite(currentAttempt) && currentAttempt > 0 ? currentAttempt : 1;
  const max = Number.isFinite(maxAttempts) && maxAttempts > 0 ? maxAttempts : Math.max(current, 3);
  return `${current} de ${max}`;
};
